// extracted by mini-css-extract-plugin
module.exports = {"mainLayout":"Main_mainLayout__1Lite","footerContainer":"Main_footerContainer__Vjv_H"};